import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-c094c024"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  style: {
    "border-radius": "7px",
    "background": "#FFF",
    "box-shadow": "6px 7px 6px 0px rgba(0, 0, 0, 0.28)",
    "border": "5px solid rgba(255, 255, 255, 0.27)",
    "position": "absolute",
    "z-index": "999999999999",
    "bottom": "12px",
    "min-height": "89px"
  }
};
var _hoisted_2 = {
  style: {
    "color": "#000",
    "text-align": "center",
    "text-shadow": "0px 4px 4px rgba(0, 0, 0, 0.25)",
    "font-family": "'Nunito Sans'",
    "font-size": "24px",
    "font-style": "normal",
    "font-weight": "300",
    "line-height": "normal"
  }
};
var _hoisted_3 = {
  style: {
    "display": "flex",
    "justify-content": "space-between",
    "width": "100%",
    "padding": "10px",
    "gap": "15px"
  }
};
var _hoisted_4 = {
  style: {
    "flex": "1"
  }
};
var _hoisted_5 = {
  key: 0,
  "class": "icon"
};
var _hoisted_6 = /*#__PURE__*/_createStaticVNode("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"42\" height=\"36\" viewBox=\"0 0 42 36\" fill=\"none\" data-v-c094c024><g filter=\"url(#filter0_d_21_729)\" data-v-c094c024><path d=\"M13.2922 28.0075L4.40064 18.962C3.86645 18.4186 3.86645 17.5375 4.40064 16.994L6.33513 15.026C6.86932 14.4825 7.73549 14.4825 8.26968 15.026L14.2594 21.1193L27.0888 8.06794C27.623 7.52451 28.4892 7.52451 29.0234 8.06794L30.9578 10.036C31.492 10.5794 31.492 11.4605 30.9578 12.004L15.2267 28.0075C14.6925 28.551 13.8263 28.551 13.2922 28.0075Z\" fill=\"white\" data-v-c094c024></path></g><defs data-v-c094c024><filter id=\"filter0_d_21_729\" x=\"0\" y=\"0.66037\" width=\"41.3585\" height=\"34.7547\" filterUnits=\"userSpaceOnUse\" color-interpolation-filters=\"sRGB\" data-v-c094c024><feFlood flood-opacity=\"0\" result=\"BackgroundImageFix\" data-v-c094c024></feFlood><feColorMatrix in=\"SourceAlpha\" type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0\" result=\"hardAlpha\" data-v-c094c024></feColorMatrix><feOffset dx=\"3\" data-v-c094c024></feOffset><feGaussianBlur stdDeviation=\"3.5\" data-v-c094c024></feGaussianBlur><feComposite in2=\"hardAlpha\" operator=\"out\" data-v-c094c024></feComposite><feColorMatrix type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0\" data-v-c094c024></feColorMatrix><feBlend mode=\"normal\" in2=\"BackgroundImageFix\" result=\"effect1_dropShadow_21_729\" data-v-c094c024></feBlend><feBlend mode=\"normal\" in=\"SourceGraphic\" in2=\"effect1_dropShadow_21_729\" result=\"shape\" data-v-c094c024></feBlend></filter></defs></svg>", 1);
var _hoisted_7 = [_hoisted_6];
var _hoisted_8 = {
  style: {
    "flex": "1"
  }
};
var _hoisted_9 = {
  key: 0,
  "class": "icon"
};
var _hoisted_10 = /*#__PURE__*/_createStaticVNode("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"42\" height=\"36\" viewBox=\"0 0 42 36\" fill=\"none\" data-v-c094c024><g filter=\"url(#filter0_d_21_729)\" data-v-c094c024><path d=\"M13.2922 28.0075L4.40064 18.962C3.86645 18.4186 3.86645 17.5375 4.40064 16.994L6.33513 15.026C6.86932 14.4825 7.73549 14.4825 8.26968 15.026L14.2594 21.1193L27.0888 8.06794C27.623 7.52451 28.4892 7.52451 29.0234 8.06794L30.9578 10.036C31.492 10.5794 31.492 11.4605 30.9578 12.004L15.2267 28.0075C14.6925 28.551 13.8263 28.551 13.2922 28.0075Z\" fill=\"white\" data-v-c094c024></path></g><defs data-v-c094c024><filter id=\"filter0_d_21_729\" x=\"0\" y=\"0.66037\" width=\"41.3585\" height=\"34.7547\" filterUnits=\"userSpaceOnUse\" color-interpolation-filters=\"sRGB\" data-v-c094c024><feFlood flood-opacity=\"0\" result=\"BackgroundImageFix\" data-v-c094c024></feFlood><feColorMatrix in=\"SourceAlpha\" type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0\" result=\"hardAlpha\" data-v-c094c024></feColorMatrix><feOffset dx=\"3\" data-v-c094c024></feOffset><feGaussianBlur stdDeviation=\"3.5\" data-v-c094c024></feGaussianBlur><feComposite in2=\"hardAlpha\" operator=\"out\" data-v-c094c024></feComposite><feColorMatrix type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0\" data-v-c094c024></feColorMatrix><feBlend mode=\"normal\" in2=\"BackgroundImageFix\" result=\"effect1_dropShadow_21_729\" data-v-c094c024></feBlend><feBlend mode=\"normal\" in=\"SourceGraphic\" in2=\"effect1_dropShadow_21_729\" result=\"shape\" data-v-c094c024></feBlend></filter></defs></svg>", 1);
var _hoisted_11 = [_hoisted_10];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$store.state.introShowAsXRated ? 'Showing Profiles as X-Rated' : 'Show Profiles As X-Rated?'), 1), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("button", {
    onClick: _cache[0] || (_cache[0] = function ($event) {
      return $options.disableXrated();
    }),
    "class": _normalizeClass({
      'button': true,
      'button--secondary': _ctx.$store.state.introShowAsXRated === false
    }),
    style: {
      "padding-top": "0px"
    }
  }, [_ctx.$store.state.introShowAsXRated === false ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7)) : _createCommentVNode("", true), _createTextVNode("No ")], 2)]), _createElementVNode("div", _hoisted_8, [_createElementVNode("button", {
    onClick: _cache[1] || (_cache[1] = function ($event) {
      return $options.showXRated();
    }),
    "class": _normalizeClass({
      'button': true,
      'button--secondary': _ctx.$store.state.introShowAsXRated === true
    }),
    style: {
      "padding-top": "0px"
    }
  }, [_ctx.$store.state.introShowAsXRated === true ? (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_11)) : _createCommentVNode("", true), _createTextVNode(" Yes ")], 2)])])]);
}